import { useTranslation } from 'react-i18next';

export default function ReviewSection() {
  const { t } = useTranslation();

  return (
    <section id="review" className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative">
            <div className="aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=hands%20opening%20cardboard%20package%20revealing%20brand%20new%20white%20sneakers%20inside%20bright%20clean%20studio%20soft%20natural%20light%20lifestyle%20unboxing%20satisfied&width=800&height=600&seq=review-1&orientation=landscape&nocache=true"
                alt="CSSBuy Review"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div>
            <span className="text-sm font-medium text-primary-600 uppercase tracking-widest mb-2 block">
              Review
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-4">
              {t('review_title')}
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-6">
              {t('review_desc')}
            </p>
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="p-4 bg-background-100 rounded-lg border border-background-200/40">
                <div className="font-heading text-2xl font-bold text-foreground-950">4.5/5</div>
                <div className="text-xs text-foreground-500 mt-1">Overall Rating</div>
              </div>
              <div className="p-4 bg-background-100 rounded-lg border border-background-200/40">
                <div className="font-heading text-2xl font-bold text-foreground-950">Free</div>
                <div className="text-xs text-foreground-500 mt-1">QC Photos</div>
              </div>
              <div className="p-4 bg-background-100 rounded-lg border border-background-200/40">
                <div className="font-heading text-2xl font-bold text-foreground-950">3%</div>
                <div className="text-xs text-foreground-500 mt-1">Service Fee</div>
              </div>
              <div className="p-4 bg-background-100 rounded-lg border border-background-200/40">
                <div className="font-heading text-2xl font-bold text-foreground-950">15+</div>
                <div className="text-xs text-foreground-500 mt-1">Shipping Lines</div>
              </div>
            </div>
            <a
              href="/article/cssbuy-review"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
            >
              Read Full Review
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}